(function(){
  var dialog=null;
  var root=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root;
  if(typeof fetch!=='function'||typeof root!=='string'
    ||!root.startsWith('/')||root.startsWith('//')||!root.endsWith('/')
    ||root.indexOf(String.fromCharCode(92))!==-1||root.indexOf('?')!==-1||root.indexOf('#')!==-1)return;
  var itemsNode=null;
  var totalNode=null;
  var errorNode=null;
  var closeButton=null;
  var checkoutButton=null;
  var initializedForms=new WeakSet();
  var busy=false;
  var opener=null;
  function bindDialog(){
    var next=document.getElementById('CartFeedback');
    if(!next||typeof next.showModal!=='function')return false;
    if(next===dialog)return true;
    var nextItems=next.querySelector('[data-feedback-items]');
    var nextTotal=next.querySelector('[data-feedback-total]');
    var nextError=next.querySelector('[data-feedback-error]');
    var nextClose=next.querySelector('[data-feedback-close]');
    var nextCheckout=next.querySelector('[data-feedback-checkout]');
    if(!nextItems||!nextTotal||!nextError||!nextClose||!nextCheckout)return false;
    dialog=next;itemsNode=nextItems;totalNode=nextTotal;errorNode=nextError;
    closeButton=nextClose;checkoutButton=nextCheckout;
    nextClose.addEventListener('click',function(){next.close()});
    next.addEventListener('close',function(){if(opener&&typeof opener.focus==='function')opener.focus()});
    return true;
  }
  function showError(message){errorNode.textContent=message;errorNode.hidden=false}
  function clearError(){errorNode.textContent='';errorNode.hidden=true}
  function open(){if(!dialog.open)dialog.showModal();closeButton.focus()}
  function money(amount,currency){
    try{return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:currency}).format(Number(amount)/100)}
    catch(_error){return '—'}
  }
  function imageUrl(raw){
    if(typeof raw!=='string'||!raw)return null;
    try{var url=new URL(raw,window.location.href);
      if(url.protocol!=='https:'||url.username||url.password)return null;
      if(url.hostname!==window.location.hostname&&url.hostname!=='cdn.shopify.com')return null;
      return url.href;
    }catch(_error){return null}
  }
  async function request(path,options){
    var response=await fetch(root+path,options||{headers:{Accept:'application/json'}});
    if(!response.ok){var error=new Error('Shopify cart request failed');
      error.knownFailure=response.status>=400&&response.status<500;throw error}
    return response.json();
  }
  function line(item,cart){
    var row=document.createElement('div');row.className='cart-feedback-row';
    var image=imageUrl(item.image);
    if(image){var img=document.createElement('img');img.src=image;img.alt='';img.loading='lazy';row.appendChild(img)}
    var detail=document.createElement('div');detail.className='cart-feedback-detail';
    var title=document.createElement('strong');title.textContent=item.product_title||item.title||'';detail.appendChild(title);
    if(item.variant_title&&item.variant_title!=='Default Title'){
      var variant=document.createElement('span');variant.textContent=item.variant_title;detail.appendChild(variant);
    }
    var unitPrice=document.createElement('span');unitPrice.textContent='Unit price '+money(item.final_price??item.price,cart.currency);
    detail.appendChild(unitPrice);
    var controls=document.createElement('div');controls.className='cart-feedback-controls';
    var label=document.createElement('label');label.textContent='Quantity';
    var quantity=document.createElement('input');quantity.type='number';quantity.min='0';quantity.max='10000';quantity.step='1';quantity.value=String(item.quantity);
    quantity.setAttribute('aria-label','Change '+(item.product_title||'product')+' quantity');
    quantity.addEventListener('change',function(){change(item.key,quantity.value)});
    label.appendChild(quantity);controls.appendChild(label);
    var remove=document.createElement('button');remove.type='button';remove.textContent='Remove';
    remove.setAttribute('aria-label','Remove '+(item.product_title||'product'));
    remove.addEventListener('click',function(){change(item.key,'0')});controls.appendChild(remove);
    detail.appendChild(controls);row.appendChild(detail);
    var price=document.createElement('span');price.className='cart-feedback-price';
    price.textContent=money(item.final_line_price??item.line_price,cart.currency);row.appendChild(price);
    return row;
  }
  function render(cart){
    itemsNode.replaceChildren();
    var items=cart.items||[];
    items.forEach(function(item){itemsNode.appendChild(line(item,cart))});
    if(!items.length){var empty=document.createElement('p');empty.textContent='Cart is empty';itemsNode.appendChild(empty)}
    checkoutButton.disabled=!items.length;
    totalNode.textContent='Cart subtotal: '+money(cart.total_price,cart.currency)+' (tax and shipping calculated at checkout)';
  }
  async function change(key,rawQuantity){
    var quantity=Number(rawQuantity);
    if(typeof key!=='string'||!key||!Number.isSafeInteger(quantity)||quantity<0||quantity>10000){showError('Enter a whole quantity from 0 to 10000');return}
    if(busy)return;
    busy=true;clearError();
    try{render(await request('cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:quantity})}))}
    catch(error){showError(error&&error.knownFailure?'Cart update failed. Check quantity or stock.':'Cart update is unconfirmed. Open the cart to check.')}
    finally{busy=false}
  }
  function bindForm(form){
    if(initializedForms.has(form))return;
    initializedForms.add(form);
    form.addEventListener('submit',async function(event){
      if(!event.submitter||event.submitter.name!=='add')return;
      if(!bindDialog())return;
      event.preventDefault();
      if(busy)return;
      if(typeof form.reportValidity==='function'&&!form.reportValidity())return;
      busy=true;opener=event.submitter;clearError();
      var button=event.submitter;button.disabled=true;
      try{
        var variant=form.querySelector('[name="id"]');var quantity=form.querySelector('[name="quantity"]');
        await request('cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({items:[{id:variant.value,quantity:Number(quantity.value)}]})});
        render(await request('cart.js'));open();
      }catch(error){itemsNode.replaceChildren();totalNode.textContent='';checkoutButton.disabled=true;
        showError(error&&error.knownFailure?'Add to cart failed. Check stock or variant.':'Add to cart is unconfirmed. Check the cart before trying again.');open()}
      finally{button.disabled=false;busy=false;
        var quantityInput=form.querySelector('[name="quantity"]');
        if(quantityInput&&typeof quantityInput.dispatchEvent==='function')quantityInput.dispatchEvent(new Event('input',{bubbles:true}))}
    });
  }
  function init(rootNode){
    bindDialog();
    if(rootNode.matches&&rootNode.matches('[data-buy-box]'))bindForm(rootNode);
    rootNode.querySelectorAll('[data-buy-box]').forEach(bindForm);
  }
  init(document);
  if(typeof document.addEventListener==='function'){
    document.addEventListener('shopify:section:load',function(event){
      if(event.target&&typeof event.target.querySelectorAll==='function')init(event.target);
    });
  }
})();
